/* Gaveta do carrinho (replica da cart-drawer Dawn do concorrente, sections/cl-cart-drawer.liquid).
   - abre no icone do carrinho (#cart-icon-bubble / a[href="/cart"]) e ao adicionar produto;
   - intercepta TODO form de /cart/add em CAPTURA (inclusive o do buy_buttons nativo) antes do JS do tema;
     com o app Kaching no buybox, o lote vem de kaching-bundles-block.items() (?kaching_bundles=true);
   - +/-/remover via /cart/change.js; o HTML volta pela Section Rendering API (?sections=cl-cart-drawer). */
(function () {
  'use strict';
  var SEC = 'cl-cart-drawer', OPEN = false;
  function root() { return document.getElementById('ClCartDrawer'); }
  function drawer() { var r = root(); return r && r.querySelector('cl-cart-drawer'); }

  function bubble(count) {
    document.querySelectorAll('#cart-icon-bubble').forEach(function (b) {
      var c = b.querySelector('.cart-count-bubble');
      if (!count) { if (c) c.remove(); return; }
      if (!c) { c = document.createElement('div'); c.className = 'cart-count-bubble'; b.appendChild(c); }
      c.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
    });
    /* Horizon: o contador vive em <cart-icon> + snippets/cart-bubble.liquid, markup
       diferente do Dawn. Sem isto o numero nao atualiza depois do add-to-cart,
       porque o cl-cart.js faz fetch cru e nao emite o evento que o cart-icon.js escuta. */
    document.querySelectorAll('cart-icon').forEach(function (ci) {
      var wrap = ci.querySelector('.cart-bubble'), num = ci.querySelector('.cart-bubble__text-count');
      if (!wrap || !num) return;
      num.textContent = count && count < 100 ? String(count) : (count ? '' : '0');
      wrap.classList.toggle('visually-hidden', !count);
      num.classList.toggle('hidden', !count);
      ci.classList.toggle('header-actions__cart-icon--has-cart', !!count);
    });
  }

  function swap(htmlText) {
    var r = root(); if (!r) return;
    var doc = new DOMParser().parseFromString(htmlText, 'text/html');
    var nr = doc.getElementById('ClCartDrawer'); if (!nr) return;
    var wasOpen = OPEN;
    var nd = nr.querySelector('cl-cart-drawer'), od = drawer();
    if (nd && od) {
      if (wasOpen) { nd.classList.add('cld-animate', 'cld-active'); }
      od.replaceWith(nd);
    }
  }
  function refresh() {
    var r = root(); if (r) r.classList.add('is-loading');
    return fetch(window.location.pathname + '?sections=' + SEC, { credentials: 'same-origin' })
      .then(function (x) { return x.json(); })
      .then(function (j) { if (j && j[SEC]) swap(j[SEC]); return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (x) { return x.json(); })
      .then(function (c) { bubble(c.item_count); if (r) r.classList.remove('is-loading'); return c; })
      .catch(function () { if (r) r.classList.remove('is-loading'); });
  }
  function isOpen() { return OPEN; }
  function open() {
    var d = drawer(); if (!d) return false;
    OPEN = true;
    root().setAttribute('aria-hidden', 'false');
    d.classList.add('cld-animate');
    // o re-render (?sections=) pode trocar o elemento antes do proximo quadro: a classe vai no ATUAL
    requestAnimationFrame(function () { if (OPEN) { var c = drawer(); if (c) c.classList.add('cld-active'); } });
    document.documentElement.classList.add('cl-cart-lock');
    return true;
  }
  function close() {
    var d = drawer(); OPEN = false; if (!d) return;
    d.classList.remove('cld-active');
    root().setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cl-cart-lock');
  }
  function change(line, q) {
    var r = root(); if (r) r.classList.add('is-loading');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, q) }) })
      .then(function () { return refresh(); });
  }
  function add(body, isJson, url) {
    return fetch(url || '/cart/add.js', { method: 'POST', headers: isJson ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' }, body: body })
      .then(function (x) { return x.json().then(function (j) { if (!x.ok) throw j; return j; }); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!root()) return;
    if (t.closest('[data-cl-cart-close]') || (t.closest('#ClCartDrawer') && t.closest('.cld-cart-drawer__overlay'))) {
      if (t.closest('a[href]') && !t.closest('[data-cl-cart-close][href]')) return;
      e.preventDefault(); close(); return;
    }
    var icon = t.closest('#cart-icon-bubble, a[href="/cart"]');
    if (icon && !t.closest('#ClCartDrawer')) {
      e.preventDefault();
      open(); refresh();
      return;
    }
    var qb = t.closest('#ClCartDrawer .cld-quantity__button');
    if (qb) {
      e.preventDefault();
      var inp = qb.parentElement.querySelector('input'), line = +inp.getAttribute('data-index');
      var q = (+inp.value || 0) + (qb.name === 'plus' ? 1 : -1);
      inp.value = Math.max(0, q); change(line, q); return;
    }
    var rm = t.closest('#ClCartDrawer cl-cart-remove-button');
    if (rm) { e.preventDefault(); change(+rm.getAttribute('data-index'), 0); }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('#ClCartDrawer .cld-quantity__input'); if (!inp) return;
    change(+inp.getAttribute('data-index'), +inp.value || 0);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });

  /* CAPTURA NO WINDOW, nao em document: o Horizon tambem delega `submit` em
     document com {capture:true} (assets/component.js), e a ordem de registro
     entre os dois nao e deterministica — com modulos + es-modules-shim, quem
     registra primeiro varia entre carregamentos. O window precede SEMPRE
     qualquer listener de document na fase de captura, entao este handler ganha
     de forma garantida. Mesma razao do gatilho do icone, mais abaixo. */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !root() || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = f.querySelector('[type="submit"]') || document.querySelector('[form="' + f.getAttribute('id') + '"][type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    /* App Kaching real (retrabalho 10-30): o lote da barra escolhida vem de items() do bloco do app, que mora
       no [data-cl-app-slot] do buybox copiado. Sem deal p/ o produto (bloco vazio) = FormData do form (1 un.). */
    var kb = null, host = f.closest('.cl-pdp-host') || (btn && btn.closest('.cl-pdp-host'));
    if (host) kb = host.querySelector('kaching-bundles-block');
    var items = null;
    if (kb && typeof kb.items === 'function') { try { items = kb.items(); } catch (_) { items = null; } }
    var p;
    if (items && items.length) p = add(JSON.stringify({ items: items }), true, '/cart/add.js?kaching_bundles=true');
    else p = add(new FormData(f), false);
    p.then(function () { open(); return refresh(); })
      .catch(function (err) { if (err && err.description) alert(err.description); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  /* Gatilho do icone de carrinho — independente de tema.
     Em CAPTURA no window: o window precede QUALQUER listener de document no
     caminho de captura, inclusive o delegador do Horizon (assets/component.js
     registra `on:click` em document com {capture:true}). Por isso o
     stopPropagation aqui impede a gaveta NATIVA do tema de abrir junto — sem
     ele as duas abriam.
     Se a secao do clone nao estiver no DOM, nao faz nada e o tema segue normal. */
  var CL_CART_TRIGGER = [
    '#cart-icon-bubble',                   // Dawn / Shrine
    '#CartDrawer-Toggle',                  // variantes Dawn
    'cart-icon',                           // Horizon: custom element dentro do botao
    '[aria-controls="cart-drawer"]',       // Horizon: o botao em si
    '[data-testid="cart-drawer-trigger"]', // Horizon
    '[on\\:click*="cart-drawer"]',         // Horizon: atributo declarativo
    '[data-cl-cart-open]',                 // escotilha manual do gerador
    'a[href="/cart"]',
    'a[href$="/cart"]'                     // /pt-br/cart, /en/cart, dominio completo
  ].join(',');

  window.addEventListener('click', function (e) {
    if (!root()) return;
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    if (t.closest('#ClCartDrawer')) return;
    if (!t.closest(CL_CART_TRIGGER)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open(); refresh();
  }, true);

  window.clCart = { open: function () { open(); return refresh(); }, close: close, refresh: refresh };
})();
